import type * as core from '../../../../../../../core'

export const query: core.mosaic.Action.Query = {
  selection: {
    '{}': {
      payload: {
        '{}': {
          insertion: {
            '{}': {
              modelId: 'ent:!ext_institutions:!institution',
              inputs: {
                '{}': {
                  records: {
                    '[]': [
                      {
                        '{}': {
                          values: {
                            '{}': {
                              '!id': {
                                '@$': 'exInstId',
                              },
                              '!code': {
                                '@$': 'exInstCode',
                              },
                              '!name': {
                                '@$': 'exInstName',
                              },
                              '!ein': {
                                '@$': 'exInstEin',
                              },
                              '!uei': {
                                '@$': 'exInstUei',
                              },
                              '!sam_name': {
                                '@$': 'exInstSamName',
                              },
                              '!address': {
                                '{}': {},
                              },
                              '!type': {
                                '@$': 'exInstType',
                              },
                            },
                          },
                        },
                      },
                    ],
                  },
                },
              },
            },
          },
        },
      },
      operation: 'dms.mutate',
    },
  },
}
